import { render, staticRenderFns } from "./CurationFooter.vue?vue&type=template&id=eb12b494&scoped=true&"
import script from "./CurationFooter.vue?vue&type=script&lang=js&"
export * from "./CurationFooter.vue?vue&type=script&lang=js&"
import style0 from "./CurationFooter.vue?vue&type=style&index=0&id=eb12b494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb12b494",
  null
  
)

export default component.exports